const DataNotAvailable = () => {
  return (
    <svg
      width="138"
      height="135"
      viewBox="0 0 138 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M92.4891 54.8974C82.7587 54.8974 72.8773 54.5026 63.6229 51.9249C54.5427 49.4052 46.2057 44.5167 38.7743 38.8619C33.8975 35.1811 29.4851 32.2434 23.1568 32.6846C16.9764 33.0273 11.0697 35.3476 6.30855 39.3032C-1.73822 46.3397 -0.519016 59.3562 2.68576 68.5061C7.52775 82.2889 22.2163 91.8684 34.7219 98.1038C49.155 105.315 65.0047 109.471 80.9124 111.91C94.8462 114.035 112.74 115.567 124.816 106.476C135.916 98.1154 138.958 79.0145 136.241 66.1257C135.578 62.3168 133.546 58.8813 130.528 56.465C122.737 50.7637 111.114 54.5723 102.359 54.7581C99.1076 54.8974 95.81 54.8974 92.4891 54.8974Z"
        fill="#DDEFFD"
      />
      <circle cx="66.8632" cy="52.4194" r="20.6694" fill="#DCD4F4" />
      <path
        d="M68.6991 134.498C92.2406 134.498 111.325 133.307 111.325 131.839C111.325 130.37 92.2406 129.18 68.6991 129.18C45.1575 129.18 26.0732 130.37 26.0732 131.839C26.0732 133.307 45.1575 134.498 68.6991 134.498Z"
        fill="#99CFF8"
      />
      <path
        d="M66.8674 7.14844C54.5491 7.14844 42.7354 12.0418 34.0251 20.7522C25.3148 29.4625 20.4214 41.2762 20.4214 53.5944C20.4214 87.6858 66.8674 119.606 66.8674 119.606C66.8674 119.606 113.313 88.1735 113.313 53.5944C113.313 41.2762 108.42 29.4625 99.7097 20.7522C90.9994 12.0418 79.1856 7.14844 66.8674 7.14844ZM66.8674 71.0117C63.25 71.0117 59.7138 69.9396 56.7054 67.9308C53.6971 65.9221 51.3516 63.0668 49.9651 59.7257C48.5787 56.3845 48.2136 52.7074 48.916 49.1589C49.6183 45.6104 51.3566 42.3496 53.9112 39.7885C56.4658 37.2274 59.7222 35.4809 63.2689 34.7695C66.8156 34.0582 70.4936 34.414 73.8383 35.7919C77.1829 37.1699 80.0441 39.5082 82.0605 42.5114C84.0769 45.5147 85.1579 49.0482 85.1671 52.6655C85.164 57.518 83.235 62.1708 79.8038 65.602C76.3727 69.0332 71.7198 70.9622 66.8674 70.9652V71.0117Z"
        fill="white"
        stroke="#522AC7"
        strokeWidth="1.62561"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.5391 1.15137C90.8468 1.15137 91.0966 1.4003 91.0967 1.70801C91.0967 2.01582 90.8469 2.26562 90.5391 2.26562C90.2314 2.2655 89.9824 2.01575 89.9824 1.70801C89.9825 1.40037 90.2314 1.15149 90.5391 1.15137Z"
        fill="#CFCFCF"
        stroke="#0B4EDB"
        strokeWidth="1.16115"
      />
      <path
        d="M38.5322 111.589C38.84 111.589 39.0897 111.838 39.0898 112.146C39.0898 112.453 38.84 112.703 38.5322 112.703C38.2245 112.703 37.9756 112.453 37.9756 112.146C37.9757 111.838 38.2246 111.589 38.5322 111.589Z"
        fill="#CFCFCF"
        stroke="#0B4EDB"
        strokeWidth="1.16115"
      />
      <path
        d="M103.952 119.102V124.095"
        stroke="#0B4EDB"
        strokeWidth="1.16115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M101.448 121.609H106.453"
        stroke="#0B4EDB"
        strokeWidth="1.16115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7275 15.75V20.7429"
        stroke="#0B4EDB"
        strokeWidth="1.16115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2144 18.2422H20.2189"
        stroke="#0B4EDB"
        strokeWidth="1.16115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M121.668 29.3359V34.3289"
        stroke="#0B4EDB"
        strokeWidth="1.16115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M119.165 31.8359H124.169"
        stroke="#0B4EDB"
        strokeWidth="1.16115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.0301 45.8672L60.6987 58.2102"
        stroke="#522AC7"
        strokeWidth="1.50949"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.6987 45.8672L73.0301 58.2102"
        stroke="#522AC7"
        strokeWidth="1.50949"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DataNotAvailable;
